/* eslint-disable */
import React, { useEffect, Fragment, useState, useCallback } from 'react'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'

import {
  TitleHeroBanner,
  TitleSubHeroBanner,
  TitleTag,
  TitleHeroBannerForSeo
} from '../../components/text'
import BackgroundHero from '../../static/images/hero-banner/halo-clean.svg'
import ImageHero from '../../static/images/hero-banner/halo-clean-image.svg'
import Mobile from '../../static/images/hero-banner/halo-clean-banner-mobile.svg'
import HeroBanner from '../../components/hero-banner'
import SliderPhone from '../../components/slider-phone'
import CardDownload from '../../components/card-download'
import Testimonial from '../../components/testimonial'
import CardJoin from '../../components/card-join'
import WhyMassage from './why-massage'
import Vendor from './vendor'
import OnDemand from './on-demand'
import BackgroundImage from '../../static/images/card-download/halo-clean.svg'
import BackgroundJoin from '../../static/images/card-join/background-clean.svg'
import IllustrationJoin from '../../static/images/card-join/illustration-clean.svg'
import haloMassageIllust from '../../static/images/card-join/halo-massage-illus.svg'
import ImageDownloadLink from '../../components/image-download/index'
import slide1 from '../../static/images/slide/clean/slide-1.webp'
import slide2 from '../../static/images/slide/clean/slide-2.webp'
import slide3 from '../../static/images/slide/clean/slide-3.webp'
import slide4 from '../../static/images/slide/clean/slide-4.webp'
import slide5 from '../../static/images/slide/clean/slide-5.webp'
import slide6 from '../../static/images/slide/clean/slide-6.webp'
import image6 from '../../static/icons/testimonial/image-6.png'
import image9 from '../../static/icons/testimonial/image-9.png'
import image5 from '../../static/icons/testimonial/image-5.png'
import FixedServices from '../../components/services-fixed/index'
import FixedServicesResponsive from '../../components/service-fixed-responsive/index'
import styled from 'styled-components'
import ServiceContent from '../../components/service-content'
import serviceContentConstant from '../../constants/service-content'
import ServiceProduct from '../../components/service-product'
import ServiceProductMobile from '../../components/service-product-mobile'
import { StyleDownload, StyleCardJoin } from './index.styles'

const {
  serviceContentType: { HC }
} = serviceContentConstant

const HaloClean = () => {
  const { t } = useTranslation()
  const [isActiveStick, setActiveStick] = useState(true)
  const [nowPosition, setCurrentPosition] = useState(0)

  const hideStick = useCallback(() => {
    setActiveStick(false)
  }, [])

  const trackScrolling = useCallback(() => {
    const currentScrollPos = window.pageYOffset
    if (currentScrollPos > nowPosition + 100) {
      setActiveStick(false)
    } else if (currentScrollPos < nowPosition + 200) {
      setActiveStick(true)
    }
    setCurrentPosition(currentScrollPos)
  }, [nowPosition])

  useEffect(() => {
    document.addEventListener('scroll', trackScrolling)
    return () => {
      document.removeEventListener('scroll', trackScrolling)
    }
  }, [trackScrolling])

  const renderServiceProduct = () => {
    if (window.innerWidth > 1023) return <ServiceProduct content={HC} />

    return <ServiceProductMobile content={HC} />
  }

  return (
    <Fragment>
      <Helmet>
        <title>
          Jasa Cleaning Service dan Pembantu Harian Terbaik | halojasa.com
        </title>
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="Jasa cleaning service atau bersih rumah, kantor, dan apartemen lengkap dengan berbagai layanan. Lengkap, mudah, murah, dan profesional!."
        />
        <meta
          property="og:title"
          content="Jasa Cleaning Service dan Pembantu Harian Terbaik | halojasa.com"
        />
        <meta property="og:site_name" content="Halo Jasa" />
        <meta
          property="og:description"
          content="Jasa cleaning service atau bersih rumah, kantor, dan apartemen lengkap dengan berbagai layanan. Lengkap, mudah, murah, dan profesional!."
        />
        <meta
          property="og:url"
          content="https://halojasa.com/jasa-cleaning-service/"
        />
        <meta
          property="og:image"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/haloclean-ls.png"
        />
        <meta
          property="og:image:secure_url"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/haloclean-ls.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image"
          itemProp="image"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/haloclean-sq.png"
        />
        <meta
          property="og:image:secure_url"
          itemProp="image"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/haloclean-sq.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="300" />
        <meta property="og:image:height" content="268" />
        <meta property="og:type" content="website" />
        <meta property="fb:app_id" content="951866408583742" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@pthalojasa" />
        <meta
          name="twitter:title"
          content="Jasa Cleaning Service dan Pembantu Harian Terbaik | halojasa.com"
        />
        <meta
          name="twitter:description"
          content="Jasa cleaning service atau bersih rumah, kantor, dan apartemen lengkap dengan berbagai layanan. Lengkap, mudah, murah, dan profesional!."
        />
        <meta
          name="twitter:image:src"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/haloclean-ls.png"
        />
        <meta
          name="keyword"
          content="cleaning service, jasa cleaning service, pembantu harian, jasa pembantu harian"
        />
        <meta
          name="p:domain_verify"
          content="4e6fcb4deba1a02d84225fad69babc0b"
        />
        <link
          rel="canonical"
          href="https://halojasa.com/jasa-cleaning-service/"
        />
      </Helmet>
      <HeroBanner
        title={
          <div>
            <TitleHeroBannerForSeo align="left">
              Jasa Cleaning Service
            </TitleHeroBannerForSeo>
            <TitleHeroBanner className="hero-title uppercase" align="left">
              Halo Clean - Daily Urban Lifestyle Service
            </TitleHeroBanner>
          </div>
        }
        picture={{
          background: BackgroundHero,
          image: ImageHero,
          mobile: Mobile
        }}
        subTitleHeroBanner={
          <TitleSubHeroBanner
            className="title-sub-banner clean-color"
            align="left"
          >
            {t('pageJasaCleaningService.part1')}
          </TitleSubHeroBanner>
        }
        paragraph={
          <div>
            <p className="hero-desc"> {t('pageJasaCleaningService.part3')}</p>
            <p className="hero-desc">{t('pageJasaCleaningService.part4')}</p>
            <h2 className="hero-seo">{t('pageJasaCleaningService.part47')}</h2>
            {/* <p className="hero-desc">mudah</p> */}
            <ImageDownloadLink />
          </div>
        }
        tag={<TitleTag>#{t('pageJasaCleaningService.part2')}</TitleTag>}
        breadCrumb={[
          {
            name: 'Beranda',
            link: '/'
          },
          {
            name: 'Layanan Kami',
            link: '/'
          },
          {
            name: 'Halo Clean',
            link: false
          }
        ]}
      ></HeroBanner>

      {renderServiceProduct()}

      <div id="content-body">
        <WhyMassage hover></WhyMassage>

        <StyleDownload>
          <CardDownload
            contentImage={haloMassageIllust}
            boxShadow="0 10px 10px 0 rgba(74, 247, 145, 0.1)"
            border="solid 1px #4af791"
            backgroundImage={BackgroundImage}
            title={t('pageJasaCleaningService.part15')}
            tag="#solusibebasrepot  "
            desc={t('pageJasaCleaningService.part16')}
          ></CardDownload>
        </StyleDownload>

        <Vendor></Vendor>

        <OnDemand></OnDemand>

        <SliderPhone
          slide="clean"
          dotBackground="#5a5ee2"
          dotColor="#fff"
          dotColorActive="#5a5ee2"
          dotBackgroundActive="#fff"
          background="linear-gradient(to left, #90b3ff, #5558e3)"
          dataImage={[slide1, slide2, slide3, slide4, slide5, slide6]}
          dataText={[
            {
              title: 'Pilih katagorie kebutuhan layanan',
              desc: 'Pilih Katagorie layanan kebersihan yang anda butuhkan'
            },
            {
              title: 'Pilih Paket atau Jumlah Ruangan',
              desc: 'Tentukan paket atau jumlah ruangan '
            },
            {
              title: 'Masukkan Informasi Pesanan',
              desc: 'Masukan alamat dan tentukan waktu pengerjaan'
            },
            {
              title: 'Pilih Metode Pembayaran',
              desc: 'Pilih Metode pembayaran yang anda inginkan '
            },
            {
              title: 'Pantau Proses Pengerjaan',
              desc: 'Sistem kami akan mencarikan pekerja terbaik untuk anda'
            },
            {
              title: 'Rating dan Ulasan',
              desc:
                'Setelah pekerjaan selesai berikan nilai dan rating kepuasan anda kepada kami.'
            }
          ]}
        ></SliderPhone>

        <StyleCardJoin>
          <CardJoin
            marginTop="100px"
            boxShadow="0 10px 10px 0 rgba(143, 116, 255, 0.05)"
            border="solid 1px #e3dbff"
            backgroundImage={BackgroundJoin}
            image={IllustrationJoin}
            title="Halo Fix – AC Kembali Sedingin Semula"
            tag="#solusimaudingin"
            desc="Siapapun anda, bergabunglah bersama Halojasa dan ciptakan kehidupan yang lebih baik"
          ></CardJoin>
        </StyleCardJoin>

        <Testimonial
          data={[
            {
              name: 'Erika',
              desc:
                '"pekerjaannya rapi dan bersih. Toilet saya jadi wangi dan tidak licin lagi. Pokoknya seneng banget bisa menggunakan layanan halo clean',
              job: 'ibu rumah tangga',
              avatarImage: image6,
              key: 1
            },
            {
              name: 'Merry ananta',
              desc:
                '"bagi saya tempat tinggal harus nyaman dan bersih, halo jasa pelayanan nya cepat dan memuaskan"',
              job: 'Ibu rumah tangga',
              avatarImage: image9,
              key: 0
            },
            {
              name: 'Leny suryanti',
              desc:
                '"para pekerjanya sangat ramah, sopan dan kompeten dengan harga yang pantas. Saya sangat senang bisa merekomendasikan jasa layanan ini kepada teman saya"',
              job: 'Leny suryanti',
              avatarImage: image5,
              key: 3
            },
            {
              name: 'Erika',
              desc:
                '"pekerjaannya rapi dan bersih. Toilet saya jadi wangi dan tidak licin lagi. Pokoknya seneng banget bisa menggunakan layanan halo clean',
              job: 'ibu rumah tangga',
              avatarImage: image6,
              key: 4
            }
          ]}
        ></Testimonial>
        <ServiceContent
          content={HC}
          isWeb={window.innerWidth > 1023 ? true : false}
        />
        {window.innerWidth > 1023 ? (
          <FixedServices></FixedServices>
        ) : (
          <FixedServicesResponsive></FixedServicesResponsive>
        )}
      </div>
    </Fragment>
  )
}

export default HaloClean
